import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserSession')
export class UserSession {

  @JsonProperty('session_token', Any)
  sessionToken: string | null = null;

  @JsonProperty('create_time_timestamp', Number)
  createTimeTimestamp: number = 0;

  @JsonProperty('device_id', Any)
  deviceId: string | null = null;

  @JsonProperty('ip_address', String)
  ipAddress: string = '';

  @JsonProperty('platform', Any)
  platform: string | null = null;

  @JsonProperty('device_os', Any)
  deviceOs: string | null = null;

  @JsonProperty('store', Any)
  store: string | null = null;

  @JsonProperty('app_version', String)
  appVersion: string = '';
}
